// Entry of js/reconnect.js: wires the reconnect policy onto the static #components-reconnect-modal
// that ReconnectModal.razor renders outside the interactive router.
import { initReconnect } from "./reconnect";

const modal = document.getElementById("components-reconnect-modal");
if (modal instanceof HTMLDialogElement && modal.dataset.probeUrl) {
    initReconnect(modal, {
        doc: document,
        blazor: () => (window as unknown as { Blazor?: import("./reconnect").BlazorReconnectApi }).Blazor,
        reload: () => location.reload(),
        fetch: (url, init) => fetch(url, init),
        probeUrl: modal.dataset.probeUrl,
    });
}
